import { waitDialog } from 'dialogs';
import type { CreateTarget } from 'actions';
import EditTrigger from '../editTrigger';

export type ShowEditTriggerArgs = { readonly mode: 'create'; readonly createIn?: CreateTarget } | { readonly mode: 'edit'; readonly id: number };

/**
 * Open the trigger create / edit dialog and resolve when it closes (so the
 * caller can refresh). Drives the existing EditTrigger externally (`hideTrigger`
 * + `forceShow` + `onRequestClose`). For edit it passes the trigger id directly
 * — EditTrigger fetches the record itself (fetchTrigger), so it works from the
 * Workspace without the list slice being populated.
 */
export const showEditTrigger = async (args: ShowEditTriggerArgs): Promise<void> => {
  if (args.mode === 'create') {
    await waitDialog<void>((ok) => <EditTrigger newTrigger hideTrigger forceShow onRequestClose={ok} createIn={args.createIn} />);
    return;
  }
  await waitDialog<void>((ok) => <EditTrigger triggerId={args.id} hideTrigger forceShow onRequestClose={ok} />);
};
